import * as slider from "@zag-js/slider";
import { useMachine, normalizeProps } from "@zag-js/react";
import { FC, useEffect, useId } from "react";
import { isNullable } from "effect/Predicate";
import { useSyncValues } from "../../hooks/use-sync-values";
import { useGrabbingCursor } from "../../hooks/use-grabbing-cursor";

export interface SliderProps {
  disabled?: boolean;
  value: number;
  onChange: (value: number) => void;
  min?: number;
}

export const Slider: FC<SliderProps> = ({
  disabled = false,
  value,
  onChange,
  min,
}) => {
  const id = useId();
  const [state, send] = useMachine(slider.machine({ id }), {
    context: { disabled },
  });

  const api = slider.connect(state, send, normalizeProps);

  useEffect(() => {
    if (isNullable(min)) return;

    if (api.value < min) {
      api.setValue(min);
    }
  }, [min, api]);

  useSyncValues({
    parentValue: value,
    setParentValue: onChange,
    transformParentValue: Math.round,
    localValue: api.value,
    setLocalValue: api.setValue,
    transformLocalValue: Math.round,
  });

  useGrabbingCursor(api.isDragging);

  return (
    <div {...api.rootProps}>
      {/* <div>
        <label {...api.labelProps}>Slider Label</label>
        <output {...api.outputProps}>{api.value}</output>
      </div> */}
      <div className="flex items-center" {...api.controlProps}>
        <div
          className="h-2.5 bg-blue-500 rounded-full flex-1"
          {...api.trackProps}
        >
          <div
            className="bg-shale-600 h-2.5 rounded-full"
            {...api.rangeProps}
          />
        </div>
        <div
          className={`h-[18px] w-[18px] bg-white rounded-full ${
            api.isDragging ? "cursor-grabbing" : "cursor-grab"
          }`}
          {...api.thumbProps}
        >
          <input {...api.hiddenInputProps} />
        </div>
      </div>
    </div>
  );
};
